import React, { useEffect, useState } from "react";
import styles from "./potential.module.css";
import { loadData } from "../../../../functions/dataLoader";

export default function Potential({ lang, resonance }) {
    const [isActive, setIsActive] = useState(false);
    const [potentials, setPotentials] = useState(null);

    useEffect(() => {
        loadData("potentials.json").then(setPotentials);
    }, []);

    if (!potentials) return;

    const potential = potentials.find((e) => e.str_id === resonance.potential);

    return (
        <div className={`${styles["potential"]} ${isActive ? `${styles["active"]}` : ""}`}>
            <div className={styles["potential-header"]}>
                <span className={styles["level"]}>Lv.{resonance.step}</span>
                <span className={`${styles["desc"]} ${styles["keyword"]}`} onClick={() => setIsActive(!isActive)}>
                    {potential.name[lang]}
                </span>
            </div>
            <div className={`${styles["flavor-text"]} ${isActive ? `${styles["active"]}` : ""}`}>{potential.desc[lang]}</div>
        </div>
    );
}
